/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './price.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';


const Price: React.FC = () => {

    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.price} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h3>A$ {activeManageOrder?.transport_original_price}</h3>
        </div>
    )
}

export default Price;